/* eslint-disable no-alert */
/* eslint-disable arrow-body-style */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable no-console */

import React from 'react';
import uuid from 'uuid/v4';
import renderHTML from 'react-render-html';
import ReactToPrint from 'react-to-print';
import { withRouter } from 'react-router';
import { Title, GET_LIST, CREATE, UPDATE, GET_ONE } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  Button,
  Typography,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Divider,
  Select,
  MenuItem,
  Snackbar,
  Dialog,
  IconButton,
  DialogContent,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {
  TextFormatOutlined,
  EditOutlined,
  RemoveRedEyeOutlined,
  MouseOutlined,
  LinkOutlined,
  CodeOutlined,
  AddOutlined,
  WidgetsOutlined,
  SaveOutlined,
  DeleteOutlined,
  ArrowUpwardOutlined,
  ArrowDownwardOutlined,
  SpaceBarOutlined,
  PrintOutlined,
  InfoOutlined,
  CloseOutlined,
} from '@material-ui/icons/';
import Logo from '../../assets/images/myipo-logo.svg';
import styleSheet from './TemplateBuilderStyle';
import dataProvider from '../../dataProvider';

/**
 * Default model types
 */
export const modelTypes = {
  text: 'text',
  currency: 'currency',
  html: 'html',
  button: 'button',
  link: 'link',
  model: 'model',
  spacing: 'spacing',
};

/**
 * Initial tool parameters
 */
const defaultToolsData = {
  [modelTypes.button]: {
    label: '',
    buttonType: null,
  },
  [modelTypes.text]: {
    text: '',
    textType: 'normal',
  },
  [modelTypes.html]: {
    html: '',
  },
  [modelTypes.link]: {
    label: '',
    linkType: null,
    url: '',
  },
  [modelTypes.spacing]: {
    value: 0,
  },
  [modelTypes.model]: {
    selectedModel: '',
  },
};

/**
 * Validator types
 */
const VALIDATORS = {
  REQUIRED: 'required',
  NO_EMPTY_SELECT: 'noEmptySelect',
  URL: 'url',
};

class EmailTemplateBuilder extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Function bindings
     */
    this.onTemplateTextFieldChange = this.onTemplateTextFieldChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTopLevelSelectChange = this.handleTopLevelSelectChange.bind(this);
    this.updateTemplate = this.updateTemplate.bind(this);
    this.filterModels = this.filterModels.bind(this);
    this.showInfoDialog = this.showInfoDialog.bind(this);
    this.hideInfoDialog = this.hideInfoDialog.bind(this);
  }

  state = {
    /**
     * Map checked models ( like Offer, Offer order etc)
     */
    modelsChecked: {},
    /**
     * Map of visible tools parameters
     */
    toolVisible: {},
    /**
     * Map of selected parameters per each tool
     */
    toolsData: defaultToolsData,
    /**
     * Data of the context being rendered. On each add action of the builder tools
     * and reorder, contextData is updated.
     */
    contextData: [],
    /**
     * Flag to indicate that Preview Pane is in Edit Mode
     */
    previewEditMode: false,
    /**
     * Flag to indicate that Preview Pane is in Display Mode
     */
    previewDisplayMode: true,
    /**
     * Info Dialog
     */
    infoDialogVisible: false,
    /**
     * Metadatas:
     *  1. Title
     *  2. Subject
     *  3. Action
     */
    templateTitle: '',
    templateSubject: '',
    templateAction: '_',
    templateType: 'C',
    validationErrors: {},
    validators: {},
    /**
     * Selected offer
     */
    selectedOffer: null,
    /**
     * API related states for following endpoints
     * 1. FETCH: Context
     * 2. FETCH: Static Content
     * 3. PUT: Template Creation
     */
    contextIsFetching: true,
    contextDidFetch: false,
    contextModel: null,
    // offersIsFetching: true,
    offersDidFetch: false,
    // offerIsFetching: false,
    // offerDidFetch: false,
    offers: null,
    staticContentIsFetching: true,
    staticContentDidFetch: false,
    staticContentModel: null,
    templateIsCreating: false,
    templateDidCreate: false,
    // emailTemplateDidFetch: false,
    // emailTemplateIsFetching: false,
    emailTemplate: null,
    apiError: null,
  };

  async componentDidMount() {
    /**
     * Get email template Details if TemplateBuilder is in update mode
     */
    if ((this.props.mode === 'update' || this.props.mode === 'show') && this.props.templateId) {
      const templateData = await this.getEmailTemplate(this.props.templateId);
      if (templateData.offerId) {
        await this.getOffer(templateData.offerId);
      }
    }
    /**
     * Fetch email template statics and context models to populate the builder
     */
    this.getStatics();
    this.getContext();
    /**
     * Fetch offerings
     */
    this.getOffers();
  }

  /**
   * Fetches email template
   */
  async getEmailTemplate(id) {
    const { data } = await dataProvider(GET_ONE, 'emailTemplates', {
      action: 'get-one',
      resource: 'emailTemplates',
      id,
    });
    /**
     * Updated checked models if context data
     */
    const checkedFields = {};
    if (data.contextFields) {
      data.contextFields.forEach((item) => {
        if (item.key === 'model' && item.value && item.value.selectedModel === 'Offer') {
          const fields = {};
          item.value.fields.forEach((field) => {
            fields[field] = {
              isChecked: true,
            };
          });
          checkedFields.Offer = {
            isChecked: true,
            fields,
          };
        }
      });
    }
    this.setState({
      // emailTemplateDidFetch: true,
      // emailTemplateIsFetching: false,
      emailTemplate: data,
      templateTitle: data.name,
      templateSubject: data.subject,
      templateAction: data.action,
      templateType: data.type,
      contextData: [
        ...data.contextFields,
      ],
      modelsChecked: {
        ...this.state.modelsChecked,
        ...checkedFields,
      },
    });
    return data;
  }

  /**
   * Fetches context models which includes generic
   * and model related inputs
   */
  async getContext() {
    const validations = this.initValidations();
    const { data } = await dataProvider(GET_LIST, 'emailTemplates', {
      action: 'get-context-models',
      resource: 'emailTemplates',
    });
    this.setState({
      contextDidFetch: true,
      contextIsFetching: false,
      contextModel: data,
      ...validations,
    });
  }

  /**
   * Fetches static and default template data
   */
  async getStatics() {
    const { data } = await dataProvider(GET_LIST, 'emailTemplates', {
      action: 'get-static-content',
      resource: 'emailTemplates',
    });
    this.setState({
      staticContentDidFetch: true,
      staticContentIsFetching: false,
      staticContentModel: data,
    });
  }

  /**
   * Fetches offer to populate offer's details when type of email
   * is offer campaign
   */
  async getOffers() {
    try {
      const { data } = await dataProvider(GET_LIST, 'offerings', {
        resource: 'offerings',
      });
      this.setState({
        offersDidFetch: true,
        // offersIsFetching: false,
        offers: data,
      });
    } catch (error) {
      this.setState({
        offersDidFetch: false,
        // offersIsFetching: false,
        offers: null,
        apiError: error,
      });
    }
  }

  /**
   * Fetches offer by id with transformed fields
   */
  async getOffer(id) {
    try {
      if (id !== '_') {
        const { data } = await dataProvider(GET_ONE, 'emailTemplates', {
          resource: 'emailTemplates',
          action: 'model',
          model: 'Offer',
          id,
        });
        this.setState({
          // offerDidFetch: true,
          // offerIsFetching: false,
          selectedOffer: data,
        });
      }
    } catch (error) {
      this.setState({
        // offerDidFetch: false,
        // offerIsFetching: false,
        selectedOffer: null,
        apiError: error,
      });
    }
  }

  /**
   * Creates / updates a template
   */
  async updateTemplate() {
    const {
      contextData,
      templateTitle: name,
      templateSubject: subject,
      templateAction: action,
      templateType: type,
      modelsChecked,
      selectedOffer,
    } = this.state;
    /**
     * Update contextfields from contextData
     */
    const contextFields = contextData.map((item) => {
      /**
       * Model transofrmations
       */
      if (item.key === modelTypes.model && item.value.selectedModel) {
        let checkedFields = [];
        const modelFields = modelsChecked[item.value.selectedModel].fields;
        Object.keys(modelFields).forEach((key) => {
          if (modelFields[key] && modelFields[key].isChecked) {
            checkedFields = [
              ...checkedFields,
              key,
            ];
          }
        });
        return {
          ...item,
          value: {
            ...item.value,
            fields: checkedFields,
          },
        };
      }
      /**
       * Link Transformations
       */
      if (item.key === modelTypes.link && item.value && item.value.linkType === 'custom') {
        return {
          ...item,
          value: {
            ...item.value,
            linkType: item.value.url,
          },
        };
      }
      return {
        ...item,
      };
    });
    this.setState({
      templateIsCreating: true,
    });
    try {
      if (this.props.mode === 'update' && this.props.templateId) {
        await dataProvider(UPDATE, 'emailTemplates', {
          action: 'update',
          resource: 'emailTemplates',
          id: this.props.templateId,
          data: {
            contextFields,
            name,
            subject,
            action,
            type,
            offerId: selectedOffer ? selectedOffer.id : null,
          },
        });
      } else {
        await dataProvider(CREATE, 'emailTemplates', {
          action: 'create',
          resource: 'emailTemplates',
          data: {
            contextFields,
            name,
            subject,
            action,
            type,
            offerId: selectedOffer ? selectedOffer.id : null,
          },
        });
      }
      this.setState({
        templateIsCreating: false,
        templateDidCreate: true,
        apiError: null,
      });
    } catch (err) {
      this.setState({
        templateIsCreating: false,
        templateDidCreate: false,
        apiError: err,
      });
    }
  }

  /**
   * Filter models based on template type
   */
  filterModels(model) {
    if (this.state.templateType === 'C') {
      return (model.key === 'Offer');
    }
    return true;
  }

  showInfoDialog() {
    this.setState({
      infoDialogVisible: true,
    });
  }

  hideInfoDialog() {
    this.setState({
      infoDialogVisible: false,
    });
  }

  /**
   * Update state based on checked models
   */
  handleModelCheck(modelKey, fieldKey) {
    let fieldsChecked = {};
    if (fieldKey) {
      fieldsChecked = {
        ...this.state.modelsChecked[modelKey].fields,
        [fieldKey]: {
          isChecked: !(
            this.state.modelsChecked[modelKey].fields[fieldKey] &&
            this.state.modelsChecked[modelKey].fields[fieldKey].isChecked
          ),
        },
      };
    }
    this.setState({
      modelsChecked: {
        ...this.state.modelsChecked,
        [modelKey]: {
          isChecked: fieldKey ? this.state.modelsChecked[modelKey].isChecked :
            !(this.state.modelsChecked[modelKey] && this.state.modelsChecked[modelKey].isChecked),
          fields: {
            ...fieldsChecked,
          },
        },
      },
    });
  }

  getValidationErrors(id, field, e) {
    let validators = [];
    if (this.state.validators[id] && this.state.validators[id][field]) {
      validators = [
        ...this.state.validators[id][field],
      ];
    }
    return this.setValidators(id, field, e.target.value, validators, this.state.validationErrors);
  }

  /**
   * Update state based on input changes
   */
  handleInputChange(id, field, e) {
    const validationErrors = this.getValidationErrors(id, field, e);
    this.setState({
      validationErrors: {
        ...this.state.validationErrors,
        [id]: {
          ...this.state.validationErrors[id],
          ...validationErrors,
        },
      },
      toolsData: {
        ...this.state.toolsData,
        [id]: {
          ...this.state.toolsData[id],
          [field]: e.target.value,
        },
      },
    });
  }

  /**
   *Add/Remove the validator when a custom URL is added/removed
   */
  handleLinkInput(id, field, e) {
    if (field === 'linkType') {
      if (e.target.value === 'custom') {
        this.setState(prevState => ({
          ...prevState,
          validators: {
            ...prevState.validators,
            [modelTypes.link]: {
              ...prevState.validators[modelTypes.link],
              url: [
                VALIDATORS.REQUIRED,
                VALIDATORS.URL,
              ],
            },
          },
        }), () => {
          this.handleInputChange(id, field, e);
        });
      } else {
        const validations = this.initValidations();
        this.setState({
          ...validations,
        }, () => {
          this.handleInputChange(id, field, e);
        });
      }
    }
  }
  /**
   * Update templateAction
   */
  async handleTopLevelSelectChange(type, e) {
    if (type === 'selectedOffer') {
      await this.getOffer(e.target.value);
      return;
    }
    this.setState({
      [type]: e.target.value,
    });
  }

  /**
   * Handle tool button click
   */
  onToolButtonClick(type) {
    const types = Object.keys(modelTypes);
    const toolsVisible = {};
    types.forEach((t) => { toolsVisible[t] = false; });
    this.setState({
      toolVisible: {
        ...toolsVisible,
        [type]: true,
      },
    });
  }

  /**
   * Handle toggling Preview Edit Mode
   */
  onTogglePreviewMode() {
    this.setState({
      previewEditMode: !this.state.previewEditMode,
      previewDisplayMode: !this.state.previewDisplayMode,
    });
  }

  /**
   * Handle input adding
   */
  onAddInput(key) {
    /**
     * Prevent adding more than one model
     */
    if (key === 'model') {
      if (this.state.contextData.find(item => item.key === 'model' && item.value.selectedModel === this.state.toolsData[key].selectedModel)) {
        alert(`Model of type ${this.state.toolsData[key].selectedModel} is already added to the template`);
        return;
      }
    }
    const id = uuid();
    /**
     * To be updated state
     */
    let state = {
      contextData: [
        ...this.state.contextData,
        {
          id,
          key,
          value: this.state.toolsData[key],
        },
      ],
      toolsData: {
        ...this.state.toolsData,
        [key]: defaultToolsData[key],
      },
      toolVisible: {
        ...this.state.toolVisible,
        [key]: false,
      },
    };
    /**
     * Validate on input add
     */
    let validationErrors = {};
    Object.keys(this.state.validators[key]).forEach((field) => {
      const fieldValidators = this.state.validators[key][field];
      const validation = this.setValidators(
        key,
        field,
        this.state.toolsData[key][field],
        fieldValidators,
        validationErrors,
      );
      validationErrors = {
        ...this.state.validationErrors,
        [key]: {
          ...validationErrors[key],
          ...validation,
        },
      };
      /**
       * If has validation errors don't reset input states
       */
      if (
        validationErrors[key] &&
        validationErrors[key][field] &&
        validationErrors[key][field].length
      ) {
        state = {};
      }
    });
    /**
     * Add input to context data
     */
    this.setState({
      ...state,
      validationErrors,
    });
  }

  /**
   * Handle context data removal
   */
  onContextDataItemRemove(id) {
    this.setState({
      contextData: this.state.contextData.filter(item => item.id !== id),
    });
  }

  /**
   * Handle context data reorder
   */
  onContextDataItemReorder(id, orderIncrement) {
    const { contextData } = this.state;
    const targetIndex = contextData.findIndex(item => item.id === id);
    if (targetIndex !== -1) {
      const destinationIndex = targetIndex + orderIncrement;
      if (contextData[destinationIndex]) {
        const tempCell = contextData[destinationIndex];
        contextData[destinationIndex] = contextData[targetIndex];
        contextData[targetIndex] = tempCell;
      }
    }
    this.setState({
      contextData,
    });
  }

  /**
   * Update template title
   */
  onTemplateTextFieldChange(id, e) {
    this.setState({
      [id]: e.target.value,
    });
  }

  /**
   * Initializes field validations
   */
  initValidations() {
    return {
      validators: {
        [modelTypes.text]: {
          text: [
            VALIDATORS.REQUIRED,
          ],
          textType: [
            VALIDATORS.NO_EMPTY_SELECT,
          ],
        },
        [modelTypes.button]: {
          label: [
            VALIDATORS.REQUIRED,
          ],
          buttonType: [
            VALIDATORS.NO_EMPTY_SELECT,
          ],
        },
        [modelTypes.link]: {
          label: [
            VALIDATORS.REQUIRED,
          ],
          linkType: [
            VALIDATORS.NO_EMPTY_SELECT,
          ],
        },
        [modelTypes.html]: {
          html: [
            VALIDATORS.REQUIRED,
          ],
        },
        [modelTypes.model]: {
          selectedModel: [
            VALIDATORS.NO_EMPTY_SELECT,
          ],
        },
        [modelTypes.spacing]: {
          value: [
            VALIDATORS.NO_EMPTY_SELECT,
          ],
        },
      },
    };
  }

  /**
   * Sets field validators
   * @param {*} type
   * @param {*} field
   * @param {*} value
   * @param  {...any} validators
   */
  setValidators(type, field, value, validators, currentValidators) {
    const errors = [];
    if (validators) {
      validators.forEach((validator) => {
        if (validator === VALIDATORS.REQUIRED) {
          const val = this.requiredValidator(value);
          if (val) {
            errors.push(val);
          }
        }
        if (validator === VALIDATORS.NO_EMPTY_SELECT) {
          const val = this.emptySelectValidator(value);
          if (val) {
            errors.push(val);
          }
        }

        if (validator === VALIDATORS.URL) {
          const val = this.urlValidator(value);
          if (val) {
            errors.push(val);
          }
        }
      });
    }
    return {
      ...(currentValidators[type] || this.state.validationErrors[type]),
      [field]: errors,
    };
  }

  requiredValidator(value) {
    if (value && value.length) {
      return null;
    }
    return 'This field is required';
  }

  emptySelectValidator(value) {
    if (value && value !== '_') {
      return null;
    }
    return 'This field is required';
  }

  urlValidator(value) {
    const regex = new RegExp('^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?');
    const matched = value.match(regex);
    if (value && value !== '_' && matched) {
      return null;
    }
    return 'Invalid url format';
  }

  /**
   * Checks if fields have errors
   * @param {*} type
   * @param {*} field
   */
  hasError(type, field) {
    return (
      this.state.validationErrors[type] &&
      this.state.validationErrors[type][field] &&
      this.state.validationErrors[type][field].length
    );
  }

  /**
   * Render the builder pane
   */
  renderBuilder() {
    const { classes: styles } = this.props;
    const {
      contextDidFetch,
      contextIsFetching,
      contextModel,
      modelsChecked,
    } = this.state;

    const renderInput = (input) => {
      const id = `model-input-${input.type}`;
      let content = null;
      let icon = null;

      const getErrors = (type, field) => (
        <div className={styles.errorMessages}>
          {
            this.state.validationErrors && this.state.validationErrors[type] && this.state.validationErrors[type][field] ?
              this.state.validationErrors[type][field].map(error => (
                <p className={styles.errorMessage}>
                  {error}
                </p>
              )) : null
          }
        </div>
      );

      switch (input.type) {
        case modelTypes.html:
          content = (
            <FormControl variant="outlined">
              <TextField
                id={id}
                label={input.label}
                multiline
                rows="8"
                rowsMax="8"
                value={this.state.toolsData[input.type].html}
                onChange={e => this.handleInputChange(input.type, 'html', e)}
                margin="normal"
              />
            </FormControl>
          );
          icon = <CodeOutlined className={styles.leftIcon} />;
          break;
        case modelTypes.text:
          content = (
            <FormControl variant="outlined">
              <TextField
                id={id}
                label={input.label}
                required
                error={this.hasError(input.type, 'text')}
                value={this.state.toolsData[input.type].text}
                onChange={e => this.handleInputChange(input.type, 'text', e)}
                margin="normal"
                multiline
                rows="2"
                rowsMax="8"
                defaultValue={input.default}
              />
              {
                getErrors(input.type, 'text')
              }
              <Select
                value={this.state.toolsData[input.type].textType || 'normal'}
                error={this.hasError(input.type, 'textType')}
                displayEmpty
                onChange={e => this.handleInputChange(input.type, 'textType', e)}
              >
                {
                  input.options.map(option => (
                    <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
                  ))
                }
              </Select>
              {
                getErrors(input.type, 'textType')
              }
            </FormControl>
          );
          icon = <TextFormatOutlined className={styles.leftIcon} />;
          break;
        case modelTypes.button:
          content = (
            <FormControl variant="outlined">
              <TextField
                id={id}
                label="Label"
                required
                error={this.hasError(input.type, 'label')}
                value={this.state.toolsData[input.type].label}
                onChange={e => this.handleInputChange(input.type, 'label', e)}
                margin="normal"
                defaultValue={input.default}
              />
              {
                getErrors(input.type, 'label')
              }
              <Select
                value={this.state.toolsData[input.type].buttonType || '_'}
                displayEmpty
                error={this.hasError(input.type, 'buttonType')}
                onChange={e => this.handleInputChange(input.type, 'buttonType', e)}
              >
                <MenuItem value="_">Select button type</MenuItem>
                {
                  input.options.map(option => (
                    <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
                  ))
                }
              </Select>
              {
                getErrors(input.type, 'buttonType')
              }
            </FormControl>
          );
          icon = <MouseOutlined className={styles.leftIcon} />;
          break;
        case modelTypes.link:
          content = (
            <FormControl variant="outlined">
              <TextField
                id={id}
                label="Label"
                required
                error={this.hasError(input.type, 'label')}
                value={this.state.toolsData[input.type].label}
                onChange={e => this.handleInputChange(input.type, 'label', e)}
                margin="normal"
                defaultValue={input.default}
              />
              {
                getErrors(input.type, 'label')
              }
              {
                this.state.toolsData.link && this.state.toolsData.link.linkType === 'custom' && (
                <React.Fragment>
                  <TextField
                    id={id}
                    label="URL"
                    required
                    error={this.hasError(input.type, 'userSelect: ')}
                    value={this.state.toolsData[input.type].url}
                    onChange={e => this.handleInputChange(input.type, 'url', e)}
                    margin="normal"
                    defaultValue={input.default}
                  />
                  {
                    getErrors(input.type, 'url')
                  }
                </React.Fragment>
                )
              }
              <Select
                error={this.hasError(input.type, 'linkType')}
                value={this.state.toolsData[input.type].linkType || '_'}
                displayEmpty
                onChange={e => this.handleLinkInput(input.type, 'linkType', e)}
              >
                <MenuItem value="_">Select link type</MenuItem>
                {
                  input.options.map(option => (
                    <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
                  ))
                }
              </Select>
              {
                getErrors(input.type, 'linkType')
              }
            </FormControl>
          );
          icon = <LinkOutlined className={styles.leftIcon} />;
          break;
        case modelTypes.model:
          content = (
            <FormControl variant="outlined">
              <Select
                error={this.hasError(input.type, 'selectedModel')}
                value={this.state.toolsData[input.type].selectedModel || '_'}
                displayEmpty
                onChange={e => this.handleInputChange(input.type, 'selectedModel', e)}
              >
                <MenuItem value="_">Select model type</MenuItem>
                {
                  input.options
                    .filter(this.filterModels)
                    .map(option => (
                      <MenuItem value={option.key}>{option.label}</MenuItem>
                    ))
                }
              </Select>
              {
                getErrors(input.type, 'selectedModel')
              }
            </FormControl>
          );
          icon = <WidgetsOutlined className={styles.leftIcon} />;
          break;
        case modelTypes.spacing:
          content = (
            <FormControl variant="outlined">
              <Select
                value={this.state.toolsData[input.type].value || '_'}
                displayEmpty
                error={this.hasError(input.type, 'value')}
                onChange={e => this.handleInputChange(input.type, 'value', e)}
              >
                <MenuItem value="_">Select spacing</MenuItem>
                {
                  input.options.map(option => (
                    <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
                  ))
                }
              </Select>
              {
                getErrors(input.type, 'value')
              }
            </FormControl>
          );
          icon = <SpaceBarOutlined className={styles.leftIcon} />;
          break;
        default:
      }
      return (
        <div className={styles.inputItem}>
          {
            content && (
              <React.Fragment>
                <Button
                  onClick={() => this.onToolButtonClick(input.type)}
                  variant="outlined"
                  className={styles.toolButton}
                >
                  {icon}
                  {input.label}
                </Button>
                {
                  this.state.toolVisible[input.type] && (
                    <div className={styles.inputItemContent}>
                      <FormControl className={styles.inputItemFormControl}>
                        {
                          content
                        }
                        <Button
                          className={styles.inputItemButton}
                          variant="contained"
                          color="secondary"
                          onClick={() => this.onAddInput(input.type)}
                        >
                          <AddOutlined className={styles.leftIcon} />
                          Add
                        </Button>
                      </FormControl>
                    </div>
                  )
                }
              </React.Fragment>
            )
          }
        </div>
      );
    };

    /**
     * Render Generic Inputs
     */
    const renderInputs = (model) => {
      return (
        <div className={styles.modelItem}>
          <br /><br />
          <Typography className={styles.title}>
            {model.label}
          </Typography>
          <br />
          <div className={styles.inputsContainer}>
            {
              model.fields.map(field => (
                renderInput(field)
              ))
            }
          </div>
        </div>
      );
    };

    /**
     * Render Model fields by selecting checkboxes
     */
    const renderModel = (model) => {
      const isModelChecked = modelsChecked[model.key] && modelsChecked[model.key].isChecked;
      /**
       * Don't show model fields for Offer if it is not selected
       */
      if (model.key === 'Offer' && !this.state.selectedOffer) return null;
      /**
       * Don't show model if offer is not added in context
       */
      if (model.key === 'Offer' && !this.state.contextData.find(item => item.key === 'model' && item.value.selectedModel === 'Offer')) return null;
      /**
       * Render all other models
       */
      return (
        <div className={styles.modelItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isModelChecked}
                onChange={() => this.handleModelCheck(model.key)}
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
            }
            label={model.label}
          />
          {
            isModelChecked && (
              <div className={styles.modelItemFields}>
                <Divider />
                <div>
                  {
                    model.fields.map(field => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              modelsChecked[model.key].fields[field.key] &&
                              modelsChecked[model.key].fields[field.key].isChecked
                            }
                            onChange={() => this.handleModelCheck(model.key, field.key)}
                            inputProps={{
                              'aria-label': 'primary checkbox',
                            }}
                          />
                        }
                        label={field.label}
                      />
                    ))
                  }
                </div>
              </div>
            )
          }
        </div>
      );
    };

    const renderActionsBar = () => {
      return (
        <div className={styles.actionsBar}>
          <ReactToPrint
            trigger={() => (
              <Button variant="contained" className={styles.actionsBarBtn}>
                <PrintOutlined className={styles.leftIcon} />
                Print
              </Button>
            )}
            content={() => this.componentRef}
          />
          <Button onClick={() => this.onTogglePreviewMode()} variant="contained" className={styles.actionsBarBtn}>
            { this.state.previewDisplayMode && (
              <React.Fragment>
                <EditOutlined className={styles.leftIcon} />
                Edit
              </React.Fragment>
            )}
            { this.state.previewEditMode && (
              <React.Fragment>
                <RemoveRedEyeOutlined className={styles.leftIcon} />
                Preview
              </React.Fragment>
            )}
          </Button>
          <Button disabled={this.state.templateIsCreating} onClick={() => this.updateTemplate()} variant="contained" color="secondary" className={styles.actionsBarBtn}>
            {
              this.state.templateIsCreating ? (
                <React.Fragment>
                  <CircularProgress size={15} className={styles.progressBtn} />
                  Save
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <SaveOutlined className={styles.leftIcon} />
                  Save
                </React.Fragment>
              )
            }
          </Button>
        </div>
      );
    };

    return (
      <React.Fragment>
        {
          contextIsFetching && <CircularProgress className={styles.progress} />
        }
        {
          contextDidFetch && contextModel && this.state.staticContentDidFetch && (
            <div className={styles.builderBody}>
              {
                renderActionsBar()
              }
              <TextField
                required
                className={styles.titleInput}
                id="templateTitle"
                label="Title"
                value={this.state.templateTitle}
                onChange={e => this.onTemplateTextFieldChange('templateTitle', e)}
                margin="normal"
              />
              <TextField
                required
                className={styles.titleInput}
                id="templateSubject"
                label="Subject"
                value={this.state.templateSubject}
                onChange={e => this.onTemplateTextFieldChange('templateSubject', e)}
                margin="normal"
              />
              <br />
              <br />

              <Select
                className={styles.topLevelSelect}
                value={this.state.templateType}
                displayEmpty
                disabled
                onChange={e => this.handleTopLevelSelectChange('templateType', e)}
              >
                {
                  Object.keys(this.state.staticContentModel.templateTypes).map(option => (
                    <MenuItem key={this.state.staticContentModel.templateTypes[option].label} value={this.state.staticContentModel.templateTypes[option].value}>
                      {this.state.staticContentModel.templateTypes[option].label}
                    </MenuItem>
                  ))
                }
              </Select>
              {
                this.state.templateType === 'T' ?
                  (
                    <React.Fragment>
                      <br />
                      <br />
                      <br />
                      <Select
                        value={this.state.templateAction}
                        displayEmpty
                        className={styles.topLevelSelect}
                        onChange={e => this.handleTopLevelSelectChange('templateAction', e)}
                      >
                        <MenuItem value="_">Select action</MenuItem>
                        {
                          this.state.staticContentModel.actions.map(option => (
                            <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
                          ))
                        }
                      </Select>
                    </React.Fragment>
                  ) : null
              }
              {
                this.state.templateType === 'C' && this.state.offersDidFetch ?
                  (
                    <React.Fragment>
                      <br />
                      <br />
                      <br />
                      <Select
                        value={this.state.selectedOffer ? this.state.selectedOffer.id : '_'}
                        displayEmpty
                        className={styles.topLevelSelect}
                        onChange={e => this.handleTopLevelSelectChange('selectedOffer', e)}
                      >
                        <MenuItem value="_">Select an offer</MenuItem>
                        {
                          this.state.offers.map(option => (
                            <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                          ))
                        }
                      </Select>
                    </React.Fragment>
                  ) : null
              }
              {
                contextDidFetch && contextModel && (
                  <React.Fragment>
                    {
                      contextModel.map(model => (
                        model.key === '_' ? renderInputs(model) : null
                      ))
                    }
                    <br />
                    <Divider />
                    <br /><br />
                    <Typography className={styles.title}>
                      Select Model fields
                    </Typography>
                    <br />
                    {
                      contextModel
                        .filter(this.filterModels)
                        .map(model => (
                        model.key !== '_' ? renderModel(model) : null
                      ))
                    }
                  </React.Fragment>
                )
              }
            </div>
          )
        }
      </React.Fragment>
    );
  }

  /**
   * Render the preview pane
   */
  renderPreview() {
    const { classes: styles } = this.props;
    const {
      previewEditMode,
      contextData,
      staticContentDidFetch,
      staticContentIsFetching,
      staticContentModel,
    } = this.state;

    const editModeActions = (id, key, value) => {
      let metadataContent = null;
      const type = (
        <b className={styles.editModeMetadataType}>
          {key}
        </b>
      );
      switch (key) {
        case modelTypes.text:
          metadataContent = (
            <p>{type} Formatting: {value.textType}</p>
          );
          break;
        case modelTypes.html:
          metadataContent = (
            <p>{type} Length: {value.html.length}</p>
          );
          break;
        case modelTypes.button:
          metadataContent = (
            <p>{type} Type: {value.buttonType}</p>
          );
          break;
        case modelTypes.link:
          metadataContent = (
            <p>{type} Type: {value.linkType}</p>
          );
          break;
        case modelTypes.spacing:
          metadataContent = (
            <p>{type}  Spaces: {value.value}</p>
          );
          break;
        case modelTypes.model:
          metadataContent = (
            <p>{type}  Name: {value.selectedModel}</p>
          );
          break;
        default:
      }
      return (
        <div className={styles.editModeActions}>
          <div className={styles.editModeActionsMetadata}>
            {
              metadataContent
            }
          </div>
          <div>
            <ArrowUpwardOutlined className={styles.editModeAction} onClick={() => this.onContextDataItemReorder(id, -1)} />
            <ArrowDownwardOutlined className={styles.editModeAction} onClick={() => this.onContextDataItemReorder(id, 1)} />
            <DeleteOutlined className={styles.editModeAction} onClick={() => this.onContextDataItemRemove(id)} />
          </div>
        </div>
      );
    };

    const buttonPreviewContent = (ctx) => {
      return (
        <div className={styles.contextPreviewButton}>
          {
            ctx.value.label
          }
        </div>
      );
    };

    const textPreviewContent = (ctx) => {
      const fontSizes = {
        normal: '16px',
        title: '20px',
        footer: '14px',
        subtitle: '18px',
      };
      return (
        <div className={styles.contextPreviewText} style={{ fontSize: fontSizes[ctx.value.textType] }}>
          {
            ctx.value.text
          }
        </div>
      );
    };

    const spacingPreviewContent = (ctx) => {
      const numberOfSpaces = ctx.value.value;
      return (
        <div className={styles.contextPreviewSpacing}>
          {
            [...Array(Number(numberOfSpaces))].map(() => <br />)
          }
        </div>
      );
    };

    const linkPreviewContent = (ctx) => {
      return (
        <div className={styles.contextPreviewLink}>
          {
            ctx.value.label
          }
        </div>
      );
    };

    const htmlPreviewContent = (ctx) => {
      return (
        <div className={styles.contextPreviewText}>
          {
            renderHTML(ctx.value.html)
          }
        </div>
      );
    };

    const modelPreviewContent = (ctx) => {
      return (
        <div className={styles.contextPreviewModel}>
          {
            Object.keys(this.state.modelsChecked)

            .filter(modelKey => ctx.value.selectedModel === modelKey)
            .map((modelKey) => {
              const model = this.state.contextModel.find(m => m.key === modelKey);
              const rows = model && this.state.modelsChecked[modelKey].isChecked ?
                model.fields.map((modelField) => {
                  const field = model.fields.find(f => f.key === modelField.key);
                  const modelFieldByKey = this.state.modelsChecked[modelKey].fields[modelField.key];
                  if (
                      field
                      && modelFieldByKey
                      && modelFieldByKey.isChecked
                    ) {
                    return (
                      <tr>
                        <td className={styles.previewModeTableKey}>{field.label}</td>
                        <td className={styles.previewModeTableValue}>{this.state.selectedOffer && modelKey === 'Offer' ? this.state.selectedOffer[field.key] : field.mock}</td>
                      </tr>
                    );
                  }
                }) : null;
                return (
                  <table className={styles.previewModelTable}>
                    <tbody>
                      {
                        rows
                      }
                    </tbody>
                  </table>
                );
            })
          }
        </div>
      );
    };

    const previewContextContent = () => (
      <React.Fragment>
        {
          contextData.map((ctx) => {
            let contextPreviewContent = null;
            switch (ctx.key) {
              case modelTypes.button:
                contextPreviewContent = buttonPreviewContent(ctx);
                break;
              case modelTypes.text:
                  contextPreviewContent = textPreviewContent(ctx);
                  break;
              case modelTypes.html:
                contextPreviewContent = htmlPreviewContent(ctx);
                break;
              case modelTypes.link:
                contextPreviewContent = linkPreviewContent(ctx);
                break;
              case modelTypes.spacing:
                contextPreviewContent = spacingPreviewContent(ctx);
                break;
              case modelTypes.model:
                contextPreviewContent = modelPreviewContent(ctx);
                break;
              default:
            }
            /**
             * Display preview or edit mode for a specifix context
             */
            return (
              <div className={`${styles.contextPreviewItem} ${previewEditMode ? styles.contextPreviewItemEdit : ''}`}>
                {
                  previewEditMode && editModeActions(ctx.id, ctx.key, ctx.value)
                }
                {
                  contextPreviewContent
                }
              </div>
            );
          })
        }
      </React.Fragment>
    );

    return (
      // eslint-disable-next-line no-return-assign
      <div ref={el => (this.componentRef = el)} className={styles.previewBodyContainer}>
        {
          staticContentIsFetching && <CircularProgress className={styles.progress} size={10} color="secondary" />
        }
        {
          staticContentDidFetch && staticContentModel && this.state.contextDidFetch && (
            <React.Fragment>
              {
                !this.state.emailTemplate || (this.state.contextData && this.state.contextData.length) ? (
                  <div className={styles.previewBody}>
                    {/* Preview Header */}
                    <div className={styles.previewHeader}>
                      <img src={staticContentModel.logo === '__default__' ? Logo : staticContentModel.logo} alt="MyIPO Logo" width="117" />
                    </div>
                    {
                      staticContentModel.header && (
                        <p className={styles.previewContent}>
                          { staticContentModel.header }
                        </p>
                      )
                    }
                    {/* Preview Content */}
                    <div className={styles.previewContentBody}>
                      { previewContextContent() }
                    </div>
                    {/* Preview ooter */}
                    <div className={styles.previewFooter}>
                      <p className={styles.previewFooterText}>
                        { staticContentModel.footer}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className={styles.previewBody}>
                    {
                      this.state.emailTemplate.html && renderHTML(this.state.emailTemplate.html)
                    }
                  </div>
                )
              }
            </React.Fragment>
          )
        }
        {
          this.props.mode === 'show' && (
            <ReactToPrint
              trigger={() => (
                <Button variant="contained" color="secondary" className={styles.showFabButton}>
                  <PrintOutlined className={styles.leftIcon} />
                </Button>
              )}
              content={() => this.componentRef}
            />
          )
        }
      </div>
    );
  }

  render() {
    const { templateDidCreate, apiError } = this.state;
    const { classes: styles } = this.props;
    const isShow = this.props.mode === 'show';
    /**
     * If template is successfuly created navigate to /emailTemplates
     * to show the list of email templates
     */
    if (templateDidCreate) {
      this.props.history.push('/emailTemplates');
    }
    return (
      <Card>
        <Button onClick={this.showInfoDialog} color="default" aria-label="add" className={styles.fab}>
          <InfoOutlined />
        </Button>
        <Dialog fullWidth onClose={this.hideInfoDialog} aria-labelledby="simple-dialog-title" open={this.state.infoDialogVisible}>
          <MuiDialogTitle disableTypography className={styles.dialogInfoTitle}>
            <Typography variant="h1">Template Builder Help</Typography>
            <IconButton aria-label="close" onClick={this.hideInfoDialog}>
              <CloseOutlined />
            </IconButton>
          </MuiDialogTitle>
          <DialogContent>
            <br />
            <div className={styles.dialogSection}>
              <p className={styles.dialogTitle}>
                Main Fields
              </p>
              <div className={styles.dialogSectionBody}>
                <b>Title</b>: Title of the email template.
              </div>
              <div className={styles.dialogSectionBody}>
                <b>Subject</b>: Default Subject Placeholder that will be used if no explicit subject is defined.
              </div>
              <div className={styles.dialogSectionBody}>
                <b>Select Action</b>: Action to perform inside the platform ( When email type is <i>Transactional</i>). That will consist in an event triggered inside the app, ex: When an offer is updated, Offer Order is created etc.
              </div>
              <div className={styles.dialogSectionBody}>
                <b>Email Type</b>: Email template can be of type <i>Campaign</i> or <i>Transactional</i>. Campaign means that it will be used as a boilerplate for upcoming Offer Campaigns. Transactional means that it will be sent when a predefined Platform Action will be triggered.
              </div>
            </div>
            <div className={styles.dialogSection}>
              <Typography variant="h3">
                Input Types
              </Typography>
            </div>
            <div className={styles.dialogSection}>
              <Typography variant="h3">
                Models
              </Typography>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          className={styles.errorNotification}
          anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
          open={apiError != null}
          autoHideDuration={5000}
          onClose={() => { this.setState({ apiError: null }); }}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{apiError ? apiError.message : ''}</span>}
        />
        <Title title="Email Template builder" />
        <CardContent>
          <Grid
            container
            direction="row"
          >
            {
              !isShow && (
                <Grid item xs={12} md={4}>
                  <div className={styles.column}>
                    {
                      this.renderBuilder()
                    }
                  </div>
                </Grid>
              )
            }
            <Grid item xs={12} md={isShow ? 12 : 8}>
              <div className={styles.column}>
                {
                  this.renderPreview()
                }
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styleSheet)(withRouter(EmailTemplateBuilder));



// WEBPACK FOOTER //
// ./src/components/EmailTemplates/TemplateBuilder.js